import { render } from "./PageB.vue?vue&type=template&id=66183c1c&scoped=true"
import script from "./PageB.vue?vue&type=script&lang=js"
export * from "./PageB.vue?vue&type=script&lang=js"

import "./PageB.vue?vue&type=style&index=0&id=66183c1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66183c1c"]])

export default __exports__